import { useEffect } from 'react';

/**
 * Append additional <script type="application/ld+json"> tags to <head>.
 * Does NOT touch title / description / canonical — pair with useSeo on the
 * parent page that owns those.
 *
 * Pass an array (or single object). Falsy entries are ignored.
 */
export default function useExtraJsonLd(items) {
  const list = (Array.isArray(items) ? items : [items]).filter(Boolean);
  const key = JSON.stringify(list);

  useEffect(() => {
    const els = list.map((ld, i) => {
      try {
        const el = document.createElement('script');
        el.type = 'application/ld+json';
        el.setAttribute('data-seo-extra', `${i}`);
        el.text = JSON.stringify(ld);
        document.head.appendChild(el);
        return el;
      } catch {
        return null;
      }
    }).filter(Boolean);
    return () => els.forEach(el => el.remove());
  }, [key]);
}
